<template>
  <div class="ns-root">
    <AdminBrandHeader :admin-info="adminInfo" @login="handelLoginBtn" />
    <slot />
    <AdminBrandFooter :brand-title="adminInfo.brand_name" :instagram="adminInfo.instagram" :line="adminInfo.line"
      :email="adminInfo.email" />
  </div>
</template>

<script setup lang="ts">
import AdminBrandHeader from '@/components/NewAdmin/AdminBrandHeader.vue'
import AdminBrandFooter from '@/components/NewAdmin/AdminBrandFooter.vue'
import { useGoTo } from '@/composables/useGoTo'

// 共享 state，頁面若已在 SSR 取得 admin 資料可直接覆寫
// 與頁面組件保持一致的初始值
const adminInfo = useState<Record<string, any>>('adminInfo', () => ({ _loaded: false }))

const { handelLoginBtn } = useGoTo()
</script>

<style scoped lang="scss">
/* 專用 Layout 變數，可視需要移到 global */
.ns-root {
  --primary: #c9a876;
  --accent: #a08660;
  --dark: #2c2c2c;
  --dark-light: #404040;
  --page: #ffffff;
  --bg: #ffffff;
  --surface: #fafafa;
  --text: #2c2c2c;
  --text-muted: #666666;
  --text-light: #999999;
  --border: #e5e5e5;
  --border-light: #f0f0f0;
  --radius: 8px;
  --shadow: 0 4px 20px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
  --shadow-hover: 0 8px 30px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.06);
  --max: 1200px;
  --s2: 8px;
  --s3: 12px;
  --s4: 16px;
  --s5: 20px;
  --s6: 28px;
  --s8: 48px;
  --s10: 64px;
  min-height: 100vh;
  background: var(--page);
  color: var(--text);
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang TC', 'Noto Sans TC', 'Segoe UI', Roboto, Helvetica, Arial;
  line-height: 1.7;
}
</style>
